import { Reducer } from "@ctra/utils";

import { types as insightTypes } from "../insights";
import { cleanup } from "../../utils/reducer";
import { NormalizedInsightList } from "../insights/schemas";
import { NormalizedQnAList } from "../ask-ida/schema";
import askIdaTypes from "../ask-ida/types";
import { DairyCowList } from "./typings";

export const initialState: DairyCowList = {};

/**
 * Herd group reducer
 * @param state
 * @param action
 */
const reducer: Reducer<DairyCowList> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case insightTypes.FETCH_INSIGHTS.fulfilled: {
      const {
        entities: { dairyCow }
      } = payload as NormalizedInsightList;

      return {
        ...state,
        ...dairyCow
      };
    }

    case askIdaTypes.FETCH_ASK_IDA_TRACKER.fulfilled: {
      const {
        entities: { dairyCow }
      } = payload as NormalizedQnAList;

      return {
        ...state,
        ...dairyCow
      };
    }
  }

  return state;
};

export default cleanup<DairyCowList>(initialState)(reducer);
